module.exports = __webpack_public_path__ + "static/media/DELETEselectArrowUp.38942a5f.svg";